var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input" }, [
    _c(
      "div",
      { staticClass: "input__input", class: _vm.getVariant("input__input") },
      [
        _c("input", {
          attrs: {
            id: _vm.id,
            type: _vm.type,
            name: _vm.id,
            readonly: _vm.disabled,
            placeholder: _vm.$t(_vm.placeholder),
            autocomplete: "off",
            required: ""
          },
          domProps: { value: _vm.value },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.clickSubmit()
            },
            input: function($event) {
              return _vm.updateValue($event.target.value)
            }
          }
        }),
        _c(
          "label",
          {
            attrs: { for: _vm.id },
            on: {
              click: function($event) {
                return _vm.clickSubmit()
              }
            }
          },
          [_vm._t("icon")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d75dfbd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d75dfbd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/input-view.vue
// module id = 428
// module chunks = 62